import React from 'react';
import PropTypes from 'prop-types';

const getText = children => {
  if (typeof children == 'string' || children instanceof String) {
    return children;
  }
  return Array.from((children.props && children.props.children) || children)
    .map(child => getText(child))
    .join('');
};

const Heading = ({ level, children }) => {
  const text = getText(children);
  return React.createElement(
    `h${level}`,
    {
      id: (text || '')
        .toLowerCase()
        .replace(/ /g, '_')
        .replace(/\W/g, ''),
    },
    children,
  );
};

Heading.propTypes = {
  level: PropTypes.number.isRequired,
  children: PropTypes.node,
};

Heading.defaultProps = {
  children: null,
};

export default Heading;
